import { render } from "./MigrationRoute.vue?vue&type=template&id=7e4c4c96"
import script from "./MigrationRoute.vue?vue&type=script&lang=ts"
export * from "./MigrationRoute.vue?vue&type=script&lang=ts"
script.render = render

export default script